import React from 'react';
import DashboardCard from './DashboardStatsCard';

interface ExposureStatsCardProps {
  profilesExposed: number;
  brokersScanned: number;
  uniqueBrokersExposed: number;
}

const ExposureStatsCard: React.FC<ExposureStatsCardProps> = ({
  profilesExposed = 179,
  brokersScanned = 358,
  uniqueBrokersExposed = 0,
}) => {
  const progress = brokersScanned > 0 ? (uniqueBrokersExposed / brokersScanned) * 100 : 0;

  return (
    <DashboardCard
      heading="Exposure Stats"
      tooltipText="This section shows how many data brokers were scanned and how many of them have your personal data exposed"
      mainStatValue={uniqueBrokersExposed}
      mainStatLabel="Brokers Exposed"
      progress={progress}
      leftStat={{ label: 'Profiles Exposed', value: profilesExposed, barColor: '#7459D9' }}
      rightStat={{ label: 'Brokers Scanned', value: brokersScanned, barColor: '#7459D980' }}
    />
  );
};

export default ExposureStatsCard;
